const ChatBlank = props => {
    return (
        <div className="card-body card-pt-2x d-flex align-items-center justify-content-center">
            <div className="cic-wrapper d-flex align-items-center justify-content-center">

            </div>
            <h2 className="card-title">Chat with Arxis</h2>
            <p> Get instant insights into your business with a simple question. </p>
        </div>
    )
}

export default ChatBlank